exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".menu-link__link{text-decoration:none}.menu-link{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;visibility:hidden;cursor:pointer;margin-bottom:60px;transform:translateY(200px)}.menu-link:last-child{margin-bottom:0}.menu-link__hover{width:200px;z-index:-1;height:50px;opacity:0;position:absolute;margin-left:50%;top:50%;background-image:linear-gradient(-135deg,#ffc3ca,#7e9df6);transform:translate3d(-50%,-50%,0) scaleX(0);transform-origin:left}.menu-link__title{font-size:112px;letter-spacing:.1em;text-transform:uppercase;color:#fff;display:block;position:relative}.menu-link__subtitle{font-family:PlayfairDisplay;font-style:italic;font-size:14px;letter-spacing:.2em;color:#cce4ff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-764010b6!./~/postcss-loader!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/Navigation/NavItem.vue
// module id = 124
// module chunks = 0